import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/flight.png'


const _hoisted_1 = { class: "ws-textbox" }
const _hoisted_2 = {
  key: 0,
  class: "leg-part"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_4 = { class: "airport-name text-dark" }
const _hoisted_5 = { class: "flight-time-der" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "frame-flight-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "No image"
  })
], -1)
const _hoisted_8 = { class: "flight-status" }
const _hoisted_9 = { class: "text-dark" }
const _hoisted_10 = { class: "flight-status-text" }
const _hoisted_11 = { class: "airport-name text-dark" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "leg-part"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_StyledSFSListFlightInfo = _resolveComponent("StyledSFSListFlightInfo")!

  return (_openBlock(), _createBlock(_component_StyledSFSListFlightInfo, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.displayFlight)
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              class: "block-item-flight"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, { class: "flightinfo text-center my-3" }, {
                  default: _withCtx(() => [
                    (_ctx.flightLegs?.length > 1)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showBtnPrev)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_el_button, {
                                      class: "leg-btn",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPressBtnLeg('prev', _ctx.displayFlight.fltref)))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_3
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_col, {
                      span: _ctx.flightLegs?.length > 1 ? 7 : 8,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_1), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.displayFlight.dep), 1),
                        _createElementVNode("div", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(_ctx.displayFlight.std, 'D MMM')) + " ", 1),
                          _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.displayFlight.etd ? 'text-decoration: line-through' : '')
                          }, _toDisplayString(_ctx.$filters.formatDate(_ctx.displayFlight.std, 'HH:mm')), 5),
                          (_ctx.displayFlight.etd)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$filters.formatDate(_ctx.displayFlight.etd, 'HH:mm')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["span"]),
                    _createVNode(_component_el_col, {
                      span: _ctx.flightLegs?.length > 1 ? 6 : 8,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(!_ctx.displayFlight.carrier ? _ctx.displayFlight.flight_number : _ctx.displayFlight.carrier + _ctx.displayFlight.flight_no), 1),
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_3) + ":", 1),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.flightStatusDisplay), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["span"]),
                    _createVNode(_component_el_col, {
                      span: _ctx.flightLegs?.length > 1 ? 7 : 8,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_2), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.displayFlight.arr), 1),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(_ctx.displayFlight.sta, 'D MMM')) + " ", 1),
                          _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.displayFlight.eta ? 'text-decoration: line-through' : '')
                          }, _toDisplayString(_ctx.$filters.formatDate(_ctx.displayFlight.sta, 'HH:mm')), 5),
                          (_ctx.displayFlight.eta)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$filters.formatDate(_ctx.displayFlight.eta, 'HH:mm')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["span"]),
                    (_ctx.flightLegs?.length > 1)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 1,
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showBtnNext)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_el_button, {
                                      class: "leg-btn",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPressBtnLeg('next', _ctx.displayFlight.fltref)))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}